var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 58,
    viewBox: "0 0 75 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0485 2.20104L37.5632 2L37.0779 2.20104L18.9619 9.70488L18.179 10.0292V10.8766L18.179 28.9925C18.179 40.4713 25.0937 50.82 35.6988 55.2127L37.0779 55.784L37.5632 55.9851L38.0485 55.784L39.4274 55.2127C50.0326 50.82 56.9473 40.4713 56.9473 28.9925V10.8766V10.0292L56.1643 9.70488L38.0485 2.20104Z",
    fill: "#AEAEAE",
    stroke: "url(#paint0_linear_550_105)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5378 3.3728L55.6536 10.8766V28.9925C55.6536 39.9584 49.0479 49.8446 38.9167 54.041L37.5378 54.6122L36.1587 54.041C26.0276 49.8446 19.4219 39.9584 19.4219 28.9925V10.8766L37.5378 3.3728Z",
    fill: "url(#paint1_linear_550_105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5615 39.5645C35.9084 39.6636 36.2057 39.4654 36.3048 39.1681L43.0922 15.8829C43.1911 15.5361 42.9931 15.1893 42.6958 15.1397L39.6737 14.2479C39.3269 14.1489 39.0296 14.347 38.9305 14.6443L32.1431 37.9295C32.044 38.2764 32.2422 38.5737 32.5395 38.6728L35.5615 39.5645ZM29.9137 34.0157L32.0936 31.6871C32.3413 31.4394 32.2918 31.0925 32.044 30.845L27.5852 26.8814L32.044 22.9674C32.2918 22.7199 32.3413 22.3235 32.0936 22.1253L29.9137 19.7967C29.7155 19.5491 29.3192 19.5491 29.0714 19.7967L21.9372 26.485C21.6895 26.6832 21.6895 27.0796 21.9372 27.3274L29.0714 34.0157C29.3192 34.2633 29.7155 34.2633 29.9137 34.0157ZM46.1639 34.0157L53.298 27.3274C53.5457 27.1292 53.5457 26.6832 53.298 26.485L46.1639 19.7967C45.9161 19.5491 45.5198 19.5491 45.3216 19.7967L43.1418 22.0757C42.9436 22.3235 42.9436 22.7199 43.1911 22.9674L47.6997 26.8814L43.1911 30.845C42.9436 31.0925 42.894 31.4394 43.1418 31.6871L45.3216 34.0157C45.5198 34.2633 45.9161 34.2633 46.1639 34.0157Z",
    fill: "url(#paint2_linear_550_105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_550_105",
    x1: 28.7946,
    y1: 26.2373,
    x2: 46.2993,
    y2: 26.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.503125,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503225
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_550_105",
    x1: 36.9773,
    y1: 29.1891,
    x2: 38.9453,
    y2: 29.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.264755,
    stopColor: "#15B897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324628,
    stopColor: "#0A735E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_550_105",
    x1: 17.4012,
    y1: 26.8587,
    x2: 57.0716,
    y2: 26.8587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508433,
    stopColor: "#C8C8C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92dbbead2206a1f3fc181107f60f4319.svg";
export { ForwardRef as ReactComponent };